;(function () {
	const CFG = window.__DA_CART_ACC__
	if (!CFG || CFG.enabled === false) return

	/** One in-flight `cart/change.js` per line so rapid swatch changes cannot finish out of order and snap the UI back. */
	const linePersistChains = Object.create(null)

	function enqueuePersistForLine(lineKey, leadV, strapV) {
		const prev = linePersistChains[lineKey] || Promise.resolve()
		linePersistChains[lineKey] = prev
			.catch(function () {})
			.then(function () {
				return persistAccessoryChoices(lineKey, leadV, strapV)
			})
			.catch(function (err) {
				console.warn('[Dog Avenue cart accessories]', err)
			})
	}

	function normalizeProps(raw) {
		const out = {}
		if (!raw) return out
		if (Array.isArray(raw)) {
			raw.forEach(function (p) {
				if (p && p.name != null) out[p.name] = p.value != null ? String(p.value) : ''
			})
			return out
		}
		if (typeof raw === 'object') {
			Object.keys(raw).forEach(function (k) {
				const v = raw[k]
				if (v === null || v === undefined) return
				out[k] = String(v)
			})
		}
		return out
	}

	function syncPickerUiFromSelect(selectEl) {
		const box = selectEl.closest('.da-free-accessories')
		if (!box) return
		const kind = selectEl.getAttribute('data-da-accessories-select')
		const val = String(selectEl.value || '').trim()

		box.querySelectorAll('[data-da-acc-swatch="' + kind + '"]').forEach(function (btn) {
			const on = val !== '' && btn.getAttribute('data-value') === val
			btn.classList.toggle('is-selected', on)
			btn.setAttribute('aria-pressed', on ? 'true' : 'false')
		})

		const preview = box.querySelector('img[data-da-acc-preview="' + kind + '"]')
		const placeholder = box.querySelector('[data-da-acc-placeholder="' + kind + '"]')
		if (!preview) return

		const activeBtn = Array.from(
			box.querySelectorAll('[data-da-acc-swatch="' + kind + '"]'),
		).find(function (b) {
			return b.getAttribute('data-value') === val
		})

		if (!val || !activeBtn) {
			preview.classList.remove('da-acc-preview__img--strap-parity')
			preview.removeAttribute('src')
			preview.alt = ''
			preview.setAttribute('hidden', '')
			if (placeholder) placeholder.removeAttribute('hidden')
			return
		}

		if (placeholder) placeholder.setAttribute('hidden', '')

		const src = activeBtn.getAttribute('data-img-src')
		const alt = activeBtn.getAttribute('data-img-alt') || ''
		if (src) preview.src = src
		preview.alt = alt
		preview.removeAttribute('hidden')
		if (kind === 'strap') {
			const parity = val === 'Ocean blue' || val === 'Tanned'
			preview.classList.toggle('da-acc-preview__img--strap-parity', parity)
		} else {
			preview.classList.remove('da-acc-preview__img--strap-parity')
		}
	}

	function initAccessoryPickerUi() {
		document.querySelectorAll('.da-free-accessories [data-da-accessories-select]').forEach(syncPickerUiFromSelect)
	}

	/**
	 * Echo drawers dispatch `dialog:after-show` once visible — reload imgs that stayed lazy/broken while hidden.
	 * Does not fix real 404s when PNGs are missing from the published theme.
	 */
	function bindDrawerAccessoryImageKick() {
		document.querySelectorAll('cart-drawer').forEach(function (drawer) {
			if (drawer.dataset.daAccImgKick === '1') return
			drawer.dataset.daAccImgKick = '1'
			drawer.addEventListener('dialog:after-show', function () {
				window.requestAnimationFrame(function () {
					drawer.querySelectorAll('.da-free-accessories img[src]').forEach(function (img) {
						img.loading = 'eager'
						const u = img.getAttribute('src')
						if (!u) return
						if (!img.complete || img.naturalWidth === 0) {
							img.removeAttribute('src')
							img.src = u
						}
					})
				})
			})
		})
	}

	function updateAccessoryCheckoutGate() {
		document.querySelectorAll('.da-cart-accessories-warning').forEach(function (el) {
			el.hidden = true
			el.textContent = ''
		})
	}

	async function persistAccessoryChoices(lineKey, leadVal, strapVal) {
		const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
			return r.json()
		})
		const item = cart.items.find(function (i) {
			return i.key === lineKey
		})
		if (!item) return

		const props = normalizeProps(item.properties)
		delete props['_da_acc']

		const lead = String(leadVal || '').trim()
		const strap = String(strapVal || '').trim()
		if (lead) props[CFG.propLead] = lead
		else delete props[CFG.propLead]
		if (strap) props[CFG.propStrap] = strap
		else delete props[CFG.propStrap]

		// Shopify cannot persist an empty properties object on a line that already had properties;
		// use a private key (hidden in `snippets/line-item.liquid`) so the payload is never `{}`.
		if (Object.keys(props).length === 0) {
			props['_da_acc'] = '1'
		}

		const sections = []
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sections },
			}),
		)

		const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				id: lineKey,
				quantity: item.quantity,
				properties: props,
				sections: sections,
			}),
		})
		const cartContent = await response.json()

		if (!response.ok) {
			console.warn('[Dog Avenue cart accessories] cart/change failed', cartContent)
			return
		}

		document.documentElement.dispatchEvent(
			new CustomEvent('cart:change', {
				bubbles: true,
				detail: {
					baseEvent: 'da-cart-accessories',
					cart: cartContent,
				},
			}),
		)

		updateAccessoryCheckoutGate()
	}

	document.addEventListener(
		'click',
		function (e) {
			const btn = e.target.closest('[data-da-acc-swatch]')
			if (!btn) return
			const kind = btn.getAttribute('data-da-acc-swatch')
			const val = btn.getAttribute('data-value')
			const box = btn.closest('.da-free-accessories')
			if (!box || !kind || val == null) return
			const select = box.querySelector('[data-da-accessories-select="' + kind + '"]')
			if (!select) return
			if (select.value === val) {
				select.value = ''
				select.dispatchEvent(new Event('change', { bubbles: true }))
				return
			}
			select.value = val
			select.dispatchEvent(new Event('change', { bubbles: true }))
		},
		true,
	)

	document.addEventListener(
		'change',
		function (e) {
			const sel = e.target.closest('[data-da-accessories-select]')
			if (!sel) return
			syncPickerUiFromSelect(sel)

			const box = sel.closest('.da-free-accessories')
			if (!box) return
			const lineKey = box.getAttribute('data-line-key')
			const leadEl = box.querySelector('[data-da-accessories-select="lead"]')
			const strapEl = box.querySelector('[data-da-accessories-select="strap"]')
			if (!lineKey || !leadEl || !strapEl) return

			const leadV = String(leadEl.value || '').trim()
			const strapV = String(strapEl.value || '').trim()
			enqueuePersistForLine(lineKey, leadV, strapV)
		},
		true,
	)

	document.documentElement.addEventListener('cart:change', function () {
		requestAnimationFrame(function () {
			initAccessoryPickerUi()
			updateAccessoryCheckoutGate()
		})
		window.setTimeout(function () {
			initAccessoryPickerUi()
			updateAccessoryCheckoutGate()
		}, 1360)
	})

	function bootAccessoryUi() {
		initAccessoryPickerUi()
		updateAccessoryCheckoutGate()
		bindDrawerAccessoryImageKick()
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bootAccessoryUi)
	} else {
		bootAccessoryUi()
	}

	document.documentElement.addEventListener('cart:change', function () {
		window.setTimeout(bindDrawerAccessoryImageKick, 120)
	})
})()
